import copy from "@virgodev/bazaar/functions/copy";
import localforage from "localforage";
import { Ref, watch } from "vue";

const store = localforage.createInstance({
  name: "persist",
  storeName: "data",
});
const timestamps = localforage.createInstance({
  name: "persist",
  storeName: "timestamps",
});

export interface PersistOptions {
  expireAfter: number;
  purgeKeys?: string[];
}

export function persist(
  refs: { [key: string]: Ref },
  opts: PersistOptions = { expireAfter: 1000 * 60 * 60 },
) {
  for (const key in refs) {
    timestamps.getItem(key).then(async (ts) => {
      if (
        !opts.expireAfter ||
        new Date(ts) > new Date(Date.now() - opts.expireAfter)
      ) {
        const value = await store.getItem(key);
        if (value || value === 0) {
          refs[key].value = value;
        }
      } else {
        await timestamps.removeItem(key);
        await store.removeItem(key);
      }
    });

    watch(
      refs[key],
      async () => {
        const cleaned = copy(refs[key].value);
        if (opts.purgeKeys) {
          for (const key of opts.purgeKeys) {
            if (cleaned[key]) {
              delete cleaned[key];
            }
          }
        }
        await timestamps.setItem(key, new Date().toISOString());
        await store.setItem(key, cleaned);
      },
      { deep: true },
    );
  }
}

export async function unpersist() {
  await store.clear();
  await timestamps.clear();
}
